import { Link } from "react-router-dom";

import { Users, Mail } from "lucide-react";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from "../../components/ui/sidebar";

const AdminPortalSidebar = () => {
  return (
    <>
      <SidebarSeparator className="mt-2" />

      <SidebarGroup>
        <SidebarGroupLabel>Admin Portal</SidebarGroupLabel>

        <SidebarGroupContent>
          <SidebarMenu>
            <Link to="/admin-portal/users">
              <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip="User Management">
                  <div>
                    <Users />
                    <span>User Management</span>
                  </div>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </Link>

            <Link to="/admin-portal/invites">
              <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip="Application Invites">
                  <div>
                    <Mail />
                    <span>Application Invites</span>
                  </div>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </Link>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    </>
  );
};

export default AdminPortalSidebar;
